export default {
    posts(state) {
        return state.posts;
    }
}